/**
 * H5 子站商品详情路由（对应 `pages/[companyId]/products/[productId].vue`）
 * 规范 URL：`/{companyId}/products/{productId}.html`
 */
export function normalizeProductIdParam(productId: string | number | null | undefined): string {
	return String(productId ?? '')
		.trim()
		.replace(/\.html$/i, '');
}

export function mobileProductDetailPath(companyId: string | number | null | undefined, productId: string | number | null | undefined): string {
	const cid = companyId != null && companyId !== '' ? String(companyId).trim() : '';
	const pid = normalizeProductIdParam(productId);
	if (!cid || !pid) return '';
	return `/${cid}/products/${pid}.html`;
}
